import { useScanDetection } from '../hooks/useScanDetection';
import { useScanEventProcessor } from '../hooks/useScanEventProcessor';

const ScanDetectionListener = () => {
  useScanEventProcessor();
  useScanDetection();

  return null;
};

export const ScanDetectionMonitor = () => <ScanDetectionListener />;
